import { useCallback, useContext } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import { useIntl } from 'react-intl'
import InputChip from 'LuxKit/Chips/InputChip'
import FilterPanelFilterGroup from 'components/Common/FilterPanel/FilterPanelFilterGroup'
import { GlobalSearchDispatchContext } from 'contexts/GlobalSearch/GlobalSearchContexts'
import { GlobalSearchStateActions } from 'contexts/GlobalSearch/GlobalSearchState'
import { DATE_SEARCH_OPTION_IDS } from 'constants/search'
import useActiveExperienceFilterChips from 'components/Experiences/hooks/useActiveExperienceFilterChips'
import useExperiencesSearchFilters from 'components/Experiences/hooks/useExperiencesSearchFilters'

const ChipsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${rem(8)};
`

function ExperienceSearchRecentFilters() {
  const intl = useIntl()
  const searchDispatch = useContext(GlobalSearchDispatchContext)
  const { setSearchFilters } = useExperiencesSearchFilters()

  const onAfterDateRemove = useCallback(() => {
    searchDispatch({ type: GlobalSearchStateActions.UNSET_CHECKIN_DATE })
    searchDispatch({ type: GlobalSearchStateActions.UNSET_CHECKOUT_DATE })
    searchDispatch({ type: GlobalSearchStateActions.SET_DATE_SEARCH_OPTION, optionId: DATE_SEARCH_OPTION_IDS.ANYTIME })
  }, [searchDispatch])

  const handleResetAll = useCallback(() => {
    setSearchFilters({})
    searchDispatch({ type: GlobalSearchStateActions.UNSET_CHECKIN_DATE })
    searchDispatch({ type: GlobalSearchStateActions.UNSET_CHECKOUT_DATE })
    searchDispatch({ type: GlobalSearchStateActions.SET_DATE_SEARCH_OPTION, optionId: DATE_SEARCH_OPTION_IDS.ANYTIME })
  }, [setSearchFilters, searchDispatch])

  const chips = useActiveExperienceFilterChips(onAfterDateRemove)

  if (chips.length === 0) {
    return null
  }

  return (
    <FilterPanelFilterGroup
      title={intl.formatMessage({
        id: 'V_cvHNSqCNqYCnh235p5',
        defaultMessage: 'Recent filters',
        description: 'Heading title for recent filters group on the search page',
      })}
      canReset
      onReset={handleResetAll}
      resetLabel={intl.formatMessage({
        id: '-9lzAJJnRIrInHwDay4s',
        defaultMessage: 'Reset all',
        description: 'Button text to reset all selected filters in the filters panel',
      })}
    >
      <ChipsContainer>
        {chips.map(chip => (
          <InputChip
            key={chip.key}
            variant="filled"
            onClick={chip.onRemove}
          >
            {chip.label}
          </InputChip>
        ))}
      </ChipsContainer>
    </FilterPanelFilterGroup>
  )
}

export default ExperienceSearchRecentFilters
